import service from '@/services/compras/compras'

const getDefaultState = () => ({
  compras: {
    nombre: '',
    SKU: '',
    descripcion: '',
    codigoRapido: '',
    tag: []
  },
  reporteComprasStats: [],

  saved: 'null'
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  SET_COMPRAS: (state, obj) => {
    state.compras = obj
    state.saved = true
  },
  SAVE_CHANGES: (state, obj) => {
    state.compras = obj
    state.saved = false
  },
  SET_REPORTE_STATS: (state, objs) => {
    let total = 0

    state.reporteComprasStats = objs.reduce((acc, item) => {
      const local = new Date(item.createdAt)
      const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
      const localDate = local.toLocaleString('es-CR', options)

      item.item.forEach(f => {
        total += f.montoTotalLinea

        const i = acc.find(prod => prod.nombre === f.nombre)
        if (!i) {
          acc.push({
            nombre: f.nombre,
            transacciones: f.cantidad,
            totalVentaNeta: f.montoTotalLinea,
            receptor: [ // en este caso el receptor es el proveedor.
              {
                id: item.receptor ? item.receptor.id : 'ND',
                nombre: item.receptor ? item.receptor.nombre : 'ND',
                transacciones: 1,
                totalVentaNeta: f.montoTotalLinea
              }
            ],
            createdAt: [
              {
                date: localDate,
                transacciones: 1,
                totalVentaNeta: f.montoTotalLinea
              }
            ]
          })
        } else {
          ;(i.transacciones += f.cantidad), (i.totalVentaNeta += f.montoTotalLinea)
          // receptor

          const id = item.receptor ? item.receptor.id : 'ND'
          const rec = i.receptor.find(r => r.id === id)

          if (!rec) {
            i.receptor.push({
              id: item.receptor ? item.receptor.id : 'ND',
              nombre: item.receptor ? item.receptor.nombre : 'ND',
              transacciones: 1,
              totalVentaNeta: f.montoTotalLinea
            })
          } else {
            rec.nombre = item.receptor ? item.receptor.nombre : 'ND'
            rec.transacciones += 1
            rec.totalVentaNeta += f.montoTotalLinea
          }

          // createdAt
          const d = i.createdAt.find(day => day.date === localDate)
          if (!d)
            i.createdAt.push({
              date: localDate,
              transacciones: 1,
              totalVentaNeta: f.montoTotalLinea
            })
          else {
            d.transacciones += 1
            d.totalVentaNeta += f.montoTotalLinea
          }
        }
      })

      return acc
    }, [])

    state.reporteComprasStats.forEach(item => {
      item.porc = (item.totalVentaNeta * 100) / total
    })
  }
}

export const actions = {
  create: ({ commit }, compras) =>
    service.create(compras).then(result => {
      if (result) {
        commit('SET_COMPRAS', result)
      }
    }),

  readById: ({ commit }, id) => service.readById(id).then(result => commit('SET_COMPRAS', result)),

  // FIXME: que hace este metodo??
  readByEmisor: ({ commit /* state, rootGetters */ }, refresh = false) => {
    // if (state.compras.id && !refresh) {
    //   return state.compras
    // }
    // return service.readByUserId(rootGetters['emisorStore/getUserId']).then(result => {
    //   if (result.compras.length !== 0) {
    //     commit('SET_COMPRAS', result.compras)
    //     return result.compras
    //   }
    //   return null
    // })
  },

  saveChanges: ({ commit }, compras) => commit('SAVE_CHANGES', compras),

  generarReporte: async ({ commit, state }, { filter, showNC }) => {
    return service.generarReporte(state.params.emisorId, filter, showNC).then(result => commit('SET_REPORTE', result))
  },

  crearEstadisticas: async ({ commit, state, rootGetters }, { filter }) => {
    return service.crearEstadisticas(rootGetters['facturacion/emisorStore/get_Id'], filter).then(result => commit('SET_REPORTE_STATS', result))
  }
}
